import {
  Autocomplete,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  IconButton,
  Button,
  Typography,
  Box,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  showSuccessSnackbar,
  showWarningSnackbar,
} from "../../../components/snackBar/snakbar";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";
import AddBox from "@mui/icons-material/AddBox";
import Chip from "@mui/material/Chip";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { MoneyFormatv2, MoneyFormatv3 } from "../../../library/MoneyFormat";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import DeletePayments from "./DeletePayments";
import DoneIcon from "@mui/icons-material/Done";
const useStyles = makeStyles({
  table: {
    "& .MuiTableCell-root": {
      border: "1px solid rgba(224, 224, 224, 1)",
    },
  },
});

function EntryTable({
  items,
  editedItems,
  tempItems,
  paymentNo,
  invNo,
  setRowIndex,
  rowIndex,
  setItems,
  setNewItemRowStatus,
  newItemRowStatus,
  setEditedItems,
  settempItems,
  setIsFocusItem,
  isFocusItem,
  closEvent,
  setCloseEvent,
  data,
  setData,
  setInvNo,
  setPaymentNo,
  newValue,
}) {
  const header = [
    {
      id: "S. No",
      label: "S. No",
      width: 20,
      align: "left",
      currency: "",
      required: "",
    },
    {
      id: "Invoice Date",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Voucher Date"
          : "Invoice Date",
      width: 80,
      align: "left",
    },
    {
      id: "Invoice Number & Balance Amount",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Voucher Number & Balance Amount (₹)"
          : "Invoice Number & Balance Amount (₹)",
      width: 140,
      align: "right",
    },
    {
      id: "Invoice Amount",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Purchase Amount"
          : "Invoice Amount (₹)",
      width: 120,
      align: "right",
      required: "",
    },
    {
      id: "Receipt Number & Unlinked Amount",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Payment Number & Unlinked Amount (₹)"
          : "Receipt Number & Unlinked Amount (₹)",
      width: 120,
      align: "right",
    },
    {
      id: "Receipt Amount",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Payment Amount (₹)"
          : "Receipt Amount (₹)",
      width: 80,
      align: "right",
    },
    {
      id: "Allocated to Invoice",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Allocated to Purchase (₹)"
          : "Allocated to Invoice (₹)",
      width: 120,
      align: "right",
    },

    {
      id: "Unlinked Receipt",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Unlinked  Payment (₹) (Cumulatiive)"
          : "Unlinked Receipt (₹) (Cumulatiive)",
      width: 100,
      align: "right",
    },
    {
      id: "Unlinked Invoice Balance",
      label:
        data?.accountName?.AccountGroupID === 7
          ? "Unlinked Purchase Balance (₹)"
          : "Unlinked Invoice Balance (₹)",
      width: 120,
      align: "right",
    },
    {
      id: "Action",
      label: "Action",
      width: 40,
      align: "center",
    },
  ];
  const classes = useStyles();
  const [deleteEntriesModal, setDeleteEntriesModal] = useState(false);
  const [successSnackbar, setsuccessSnakbar] = useState([]);
  const [entryIndex, setEntryIndex] = useState("");
  const moveCursorToEnd = (event) => {
    event.target.focus();
    event.target.setSelectionRange(
      event.target.value.length,
      event.target.value.length
    );
  };
  function closeChangesInRows(ind) {
    setNewItemRowStatus(false);
    let isvalid = true;
    let tempobj = { ...tempItems };
    let editedobj = { ...editedItems };

    if (tempobj.invoiceNumber.value === "") {
      isvalid = false;
    }
    if (tempobj.paymentNumber.value === "") {
      isvalid = false;
    }

    if (tempobj.linkedAmount === 0) {
      isvalid = false;
    }

    if (editedItems.new) {
      let arr = [...items].filter((item, index) => {
        if (ind != index) {
          return item;
        }
      });
      setItems(arr);
      setEditedItems({});
      settempItems({});
    } else {
      let obj = { ...tempItems };
      obj.editable = false;
      obj.new = false;
      let arr = [...items];
      arr[ind] = obj;
      setItems(arr);
      setEditedItems({});
      settempItems({});
    }
  }
  function saveChangesInRows(ind) {
    let isvalid = true;
    let editedobj = { ...editedItems };
    let requireds = [];
    if (editedobj?.invoiceNumber?.value === "") {
      isvalid = false;
      requireds.push(
        data?.accountName?.AccountGroupID === 7
          ? "Voucher Number is required"
          : "Invoice Number is required"
      );
    }
    if (editedobj?.paymentNumber?.value === "") {
      isvalid = false;
      requireds.push(
        data?.accountName?.AccountGroupID === 7
          ? "Payment Number is required"
          : "Receipt Number is required"
      );
    }
    if (editedobj?.linkedAmount === 0 || editedobj?.linkedAmount === "") {
      isvalid = false;
      requireds.push("Allocated  Amount is required");
    }
    if (Number(editedobj?.linkedAmount) > Number(editedItems.paymentAmount)) {
      isvalid = false;
      requireds.push(
        data?.accountName?.AccountGroupID === 7
          ? "Allocated  Amount should not be greater than Receipt Amount"
          : "Allocated  Amount should not be greater than Payment Amount"
      );
    }

    if (isvalid) {
      let obj = { ...editedItems };
      obj.editable = false;
      obj.new = false;
      let arr = [...items];
      arr[ind] = obj;
      DisplayLinkToInvoiceTable(arr);
      // const uniqueIds = [];
      // let tempArray = [];
      // console.log("arr44", arr);
      // const unique = arr.filter((element) => {
      //   const isDuplicate =
      //     uniqueIds.includes(element?.paymentNumber?.label) &&
      //     uniqueIds.includes(element?.invoiceNumber?.label);
      //   if (!isDuplicate) {
      //     uniqueIds.push(element?.paymentNumber, element?.invoiceNumber);
      //     tempArray.push({
      //       date: element.date,
      //       invoiceNumber: {
      //         label: element?.invoiceNumber?.label,
      //         value: element?.invoiceNumber?.value,
      //         invAmt: Number(element?.invoiceNumber?.invAmt),
      //         date: element?.invoiceNumber?.date,
      //         initialInvAmt: Number(element?.invoiceNumber?.initialInvAmt),
      //         balancamt: Number(element?.invoiceNumber?.balancamt),
      //         transactionTypeCD: element?.invoiceNumber?.transactionTypeCD,
      //       },
      //       invoiceAmount: Number(element?.invoiceAmount),
      //       paymentNumber: {
      //         label: element?.paymentNumber?.label,
      //         value: element?.paymentNumber?.value,
      //         payAmt: Number(element?.paymentNumber?.payAmt),
      //         date: Number(element?.paymentNumber?.date),
      //         balancamt: Number(element?.paymentNumber?.balancamt),
      //         initialPayAmt: Number(element?.paymentNumber?.initialPayAmt),
      //         transactionTypeCD: element?.paymentNumber?.transactionTypeCD,
      //       },
      //       paymentAmount: Number(element?.paymentAmount),
      //       linkedAmount: Number(element.linkedAmount),
      //       unlinkedPaymentAmount: Number(element?.paymentNumber?.payAmt),
      //       invoiceBalanceAmount: Number(element?.invoiceNumber?.invAmt),
      //       editable: element?.editable,
      //       new: element?.new,
      //     });
      //     return true;
      //   } else {
      //     tempArray.filter((item) => {
      //       if (
      //         element.invoiceNumber?.label == item.invoiceNumber?.label &&
      //         item.paymentNumber?.label == element.paymentNumber?.label
      //       ) {
      //         item.linkedAmount += Number(element.linkedAmount);
      //         item.date = element.date;
      //         item.invoiceNumber = {
      //           label: element?.invoiceNumber?.label,
      //           value: element?.invoiceNumber?.value,
      //           invAmt: Number(element?.invoiceNumber?.invAmt),
      //           date: element?.invoiceNumber?.date,
      //           initialInvAmt: Number(element?.invoiceNumber?.initialInvAmt),
      //           balancamt: Number(element?.invoiceNumber?.balancamt),
      //           transactionTypeCD: element?.invoiceNumber?.transactionTypeCD,
      //         };
      //         item.invoiceAmount = Number(
      //           element?.invoiceNumber?.initialInvAmt
      //         );
      //         item.paymentNumber = {
      //           label: element?.paymentNumber?.label,
      //           value: element?.paymentNumber?.value,
      //           payAmt: Number(element?.paymentNumber?.payAmt),
      //           date: Number(element?.paymentNumber?.date),
      //           balancamt: Number(element?.paymentNumber?.balancamt),
      //           initialPayAmt: Number(element?.paymentNumber?.initialPayAmt),
      //           transactionTypeCD: element?.paymentNumber?.transactionTypeCD,
      //         };
      //         item.paymentAmount = Number(
      //           element?.paymentNumber?.initialPayAmt
      //         );
      //         item.unlinkedPaymentAmount = Number(
      //           element?.paymentNumber?.payAmt
      //         );
      //         item.invoiceBalanceAmount = Number(
      //           element?.invoiceNumber?.invAmt
      //         );
      //         item.editable = element?.editable;
      //         item.new = element?.new;
      //       }
      //     });
      //   }
      //   return false;
      // });
      setItems(arr);
      settempItems({});
      setEditedItems({});
      setNewItemRowStatus(false);
      setIsFocusItem(false);
      setRowIndex("");
      itemWiseNewRow();
    } else {
      if (requireds.length > 0) {
        showWarningSnackbar(`${requireds}`);
      }
    }
  }
  function DisplayLinkToInvoiceTable(arr) {
    let zeroInvVoucher = "";
    let zeroPaymentVoucher = "";
    let invBalance = 0;
    let paymentBalance = 0;
    arr.map((ele) => {
      if (Number(ele.invoiceBalanceAmount) === 0) {
        zeroInvVoucher = ele?.invoiceNumber?.label;
      }
      if (Number(ele.unlinkedPaymentAmount) === 0) {
        zeroPaymentVoucher = ele?.paymentNumber?.label;
      }
    });
    let filterInvNo = invNo.filter((ele) => {
      if (ele?.label !== zeroInvVoucher) {
        return ele;
      }
    });
    filterInvNo.map((ele) => {
      arr.map((subele) => {
        if (ele?.label === subele?.invoiceNumber?.label) {
          invBalance += Number(subele.linkedAmount);
          ele.invAmt = Number(ele.initialInvAmt) - Number(invBalance);
          ele.balancamt = Number(ele.initialInvAmt) - Number(invBalance);
        }
      });
    });
    let filterPaymentNo = paymentNo.filter((ele) => {
      if (ele?.label !== zeroPaymentVoucher) {
        return ele;
      }
    });
    filterPaymentNo.map((ele) => {
      arr.map((subele) => {
        if (ele?.label === subele?.paymentNumber?.label) {
          paymentBalance += Number(subele.linkedAmount);
          ele.payAmt = Number(ele.initialPayAmt) - Number(paymentBalance);
          ele.balancamt = Number(ele.initialPayAmt) - Number(paymentBalance);
        }
      });
    });
    setPaymentNo(filterPaymentNo);
    setInvNo(filterInvNo);
  }
  function itemWiseNewRow() {
    setNewItemRowStatus(true);
    if (items.length > 0) {
      setItems((prev) => [
        ...prev,
        {
          date: "",
          invoiceNumber: {
            label: "",
            value: "",
            invAmt: 0,
            date: "",
            balancamt: 0,
            transactionTypeCD: "",
          },
          invoiceAmount: 0,
          paymentNumber: {
            label: "",
            value: "",
            payAmt: 0,
            date: "",
            balancamt: 0,
            transactionTypeCD: "",
          },
          paymentAmount: 0,
          linkedAmount: 0,
          unlinkedPaymentAmount: 0,
          invoiceBalanceAmount: 0,
          editable: true,
          new: true,
          order: 1,
        },
      ]);

      setEditedItems({
        date: "",
        invoiceNumber: {
          label: "",
          value: "",
          invAmt: 0,
          date: "",
          balancamt: 0,
          transactionTypeCD: "",
        },
        invoiceAmount: 0,
        paymentNumber: {
          label: "",
          value: "",
          payAmt: 0,
          date: "",
          balancamt: 0,
          transactionTypeCD: "",
        },
        paymentAmount: 0,
        linkedAmount: 0,
        unlinkedPaymentAmount: 0,
        invoiceBalanceAmount: 0,
        editable: true,
        new: true,
        order: 1,
      });
      settempItems({
        date: "",
        invoiceNumber: {
          label: "",
          value: "",
          invAmt: 0,
          date: "",
          balancamt: 0,
          transactionTypeCD: "",
        },
        invoiceAmount: 0,
        paymentNumber: {
          label: "",
          value: "",
          payAmt: 0,
          date: "",
          balancamt: 0,
          transactionTypeCD: "",
        },
        paymentAmount: 0,
        linkedAmount: 0,
        unlinkedPaymentAmount: 0,
        invoiceBalanceAmount: 0,
        editable: true,
        new: true,
        order: 1,
      });
    } else {
      setItems((prev) => [
        ...prev,
        {
          date: "",
          invoiceNumber: {
            label: "",
            value: "",
            invAmt: 0,
            date: "",
            balancamt: 0,
            transactionTypeCD: "",
          },
          invoiceAmount: 0,
          paymentNumber: {
            label: "",
            value: "",
            payAmt: 0,
            date: "",
            balancamt: 0,
            transactionTypeCD: "",
          },
          paymentAmount: 0,
          linkedAmount: 0,
          unlinkedPaymentAmount: 0,
          invoiceBalanceAmount: 0,
          editable: true,
          new: true,
          order: 1,
        },
      ]);

      setEditedItems({
        date: "",
        invoiceNumber: {
          label: "",
          value: "",
          invAmt: 0,
          date: "",
          balancamt: 0,
          transactionTypeCD: "",
        },
        invoiceAmount: 0,
        paymentNumber: {
          label: "",
          value: "",
          payAmt: 0,
          date: "",
          balancamt: 0,
          transactionTypeCD: "",
        },
        paymentAmount: 0,
        linkedAmount: 0,
        unlinkedPaymentAmount: 0,
        invoiceBalanceAmount: 0,
        editable: true,
        new: true,
        order: 1,
      });
      settempItems({
        date: "",
        invoiceNumber: {
          label: "",
          value: "",
          invAmt: 0,
          date: "",
          balancamt: 0,
          transactionTypeCD: "",
        },
        invoiceAmount: 0,
        paymentNumber: {
          label: "",
          value: "",
          payAmt: 0,
          date: "",
          balancamt: 0,
          transactionTypeCD: "",
        },
        paymentAmount: 0,
        linkedAmount: 0,
        unlinkedPaymentAmount: 0,
        invoiceBalanceAmount: 0,
        editable: true,
        new: true,
        order: 1,
      });
    }
  }
  function handleLinkedAmount(value) {
    if (value <= Number(editedItems.paymentAmount)) {
      setEditedItems((prev) => ({
        ...prev,
        invoiceBalanceAmount: Number(editedItems.invoiceAmount) - Number(value),
        unlinkedPaymentAmount:
          Number(editedItems.paymentAmount) - Number(value),
      }));
    } else {
      data?.accountName?.AccountGroupID === 7
        ? showWarningSnackbar(
            "Allocated  Amount should not be greater than Receipt Amount"
          )
        : showWarningSnackbar(
            "Allocated  Amount should not be greater than Payment Amount"
          );
      setEditedItems((prev) => ({
        ...prev,
        linkedAmount: Number(editedItems.paymentAmount),
        invoiceBalanceAmount:
          Number(editedItems.invoiceAmount) - Number(editedItems.paymentAmount),
        unlinkedPaymentAmount:
          Number(editedItems.paymentAmount) - Number(editedItems.paymentAmount),
      }));
    }
  }
  function setTotalAmounts() {
    let totInvBal = 0;
    let totPaBal = 0;
    items.map((ele) => {
      totInvBal += Number(ele.invoiceBalanceAmount);
      totPaBal += Number(ele.unlinkedPaymentAmount);
    });
    let editedInvBalace = 0;
    editedInvBalace =
      editedItems.invoiceBalanceAmount >= 0
        ? Number(editedItems.invoiceBalanceAmount)
        : 0;
    let editedPaymenrBalace = 0;
    editedPaymenrBalace =
      editedItems.unlinkedPaymentAmount > 0
        ? Number(editedItems.unlinkedPaymentAmount)
        : 0;
    totInvBal = Number(totInvBal) + Number(editedInvBalace);
    totPaBal = Number(totPaBal) + Number(editedPaymenrBalace);
    setData((prev) => ({
      ...prev,
      unlinkedInvAmount: Number(totInvBal),
      unlinkedPayAmount: Number(totPaBal),
    }));
  }
  function resetTable() {
    setEditedItems({});
    settempItems([]);
    setItems([]);
    itemWiseNewRow();
  }
  useEffect(() => {
    if (newValue.value !== "") {
      resetTable();
    }
  }, [newValue]);
  useEffect(() => {
    const keyDownHandler = (event) => {
      if (isFocusItem === true) {
        if (event.key === "Enter") {
          if (
            event.target.id !== "invoiceNmber" &&
            event.target.id !== "paymentNumber"
          ) {
            if (rowIndex !== "") {
              saveChangesInRows(rowIndex);
            }
          }
        }
        if (event.key === "Tab") {
          if (rowIndex !== "" && event.target.name === "linkedAmount") {
            saveChangesInRows(rowIndex);
          }
        }
      }
    };
    const component = document.getElementById("EntryTable");
    if (component) {
      component.addEventListener("keydown", keyDownHandler);
    }

    return () => {
      if (component) {
        component.removeEventListener("keydown", keyDownHandler);
      }
    };
  }, [editedItems]);
  useEffect(() => {
    const mouseClick = (event) => {
      if (
        editedItems?.invoiceNumber?.label !== "" &&
        editedItems?.paymentNumber?.label !== "" &&
        editedItems?.linkedAmount !== 0
      ) {
        if (rowIndex !== "") {
          saveChangesInRows(rowIndex);
        }
      }
    };
    document.addEventListener("click", mouseClick, true);
    return () => {
      document.removeEventListener("click", mouseClick, true);
    };
  }, [isFocusItem]);
  useEffect(() => {
    setTotalAmounts();
  }, [editedItems, items]);
  useEffect(() => {
    if (closEvent === false) {
      if (items.length === 0 || Object.keys(editedItems).length === 0) {
        itemWiseNewRow();
      }
    }
  }, [items, editedItems]);
  return (
    <Paper
      sx={{
        borderRadius: "8px",
        backgroundColor: "background.paper",
        marginBottom: "10px",
        boxShadow:
          "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
        padding: { xs: "10px 0px", sm: "10px 10px" },
        borderRadius: "8px",
        transition: "all 1s ease-in-out",
        boxShadow:
          "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
        ":hover": {
          boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
        },
        transition: "all 1s ease-in-out",
        ".MuiTableCell-root": {
          padding: "0px 5px",
        },
        ".MuiTableCell-head": {
          borderBottom: "0px",
          fontWeight: "bold",
        },
      }}
    >
      <TableContainer>
        <Table
          stickyHeader
          className={classes.table}
          id="EntryTable"
          onMouseEnter={() => {
            setIsFocusItem(true);
          }}
          onMouseLeave={() => setIsFocusItem(false)}
        >
          <TableHead sx={{ height: "40px" }}>
            <TableRow>
              {header.map((col, ind) => {
                return (
                  <TableCell
                    key={ind}
                    align={col.align}
                    width={col.width}
                    sx={{
                      fontWeight: 600,
                      fontSize: "12px",
                      color: "input.label",
                      backgroundColor: "background.tablebg",
                    }}
                  >
                    <Typography variant="h4"> {col.label}</Typography>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.length > 0 ? (
              items.map((col, index) => {
                if (col.editable) {
                  return (
                    <>
                      <TableRow key={index} height="30px">
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{editedItems?.date}</TableCell>
                        <TableCell align="left">
                          <Box height="40px" sx={{ display: "flex" }}>
                            <Autocomplete
                              disableClearable
                              disablePortal
                              options={invNo}
                              value={editedItems?.invoiceNumber}
                              size="small"
                              name="invoiceNumber"
                              id="invoiceNumber"
                              fullWidth
                              onChange={(e, newValue) => {
                                if (newValue) {
                                  setRowIndex(index);
                                  setEditedItems((prev) => ({
                                    ...prev,
                                    invoiceNumber: newValue,
                                    date: newValue.date,
                                    invoiceAmount: Number(newValue.invAmt),
                                    invoiceBalanceAmount:
                                      Number(newValue.invAmt) -
                                      Number(editedItems.linkedAmount),
                                  }));
                                }
                              }}
                              isOptionEqualToValue={(option, value) =>
                                option == value
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                />
                              )}
                              sx={{
                                "& fieldset": { border: "none" },
                              }}
                            />

                            {editedItems.invoiceNumber.label !== "" && (
                              <Chip
                                color="success"
                                icon={
                                  <CurrencyRupeeIcon
                                    style={{
                                      fontSize: "1rem",
                                    }}
                                  />
                                }
                                label={MoneyFormatv3(
                                  editedItems?.invoiceBalanceAmount
                                )}
                                size="small"
                                sx={{
                                  m: 1,
                                }}
                              />
                            )}
                          </Box>
                        </TableCell>

                        <TableCell align="right">
                          {MoneyFormatv3(editedItems.invoiceAmount)}
                        </TableCell>
                        <TableCell align="left">
                          <Box height="40px" sx={{ display: "flex" }}>
                            <Autocomplete
                              disableClearable
                              disabled={
                                editedItems.invoiceNumber.label !== ""
                                  ? false
                                  : true
                              }
                              disablePortal
                              options={paymentNo}
                              value={editedItems?.paymentNumber}
                              name="paymentNumber"
                              id="paymentNumber"
                              size="small"
                              fullWidth
                              option={paymentNo}
                              isOptionEqualToValue={(option, value) =>
                                option == value
                              }
                              onChange={(e, newValue) => {
                                if (newValue) {
                                  setRowIndex(index);
                                  setEditedItems((prev) => ({
                                    ...prev,
                                    paymentNumber: newValue,
                                    paymentAmount: newValue.payAmt,
                                    unlinkedPaymentAmount:
                                      Number(newValue.payAmt) -
                                      Number(editedItems.linkedAmount),
                                  }));
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  {...params}
                                  InputProps={{
                                    ...params.InputProps,
                                  }}
                                />
                              )}
                              sx={{
                                "& fieldset": { border: "none" },
                              }}
                            />

                            {editedItems.paymentNumber.label !== "" && (
                              <Chip
                                color="success"
                                icon={
                                  <CurrencyRupeeIcon
                                    style={{
                                      fontSize: "1rem",
                                    }}
                                  />
                                }
                                label={MoneyFormatv3(
                                  editedItems?.unlinkedPaymentAmount
                                )}
                                size="small"
                                sx={{
                                  m: 1,
                                }}
                              />
                            )}
                          </Box>
                        </TableCell>
                        <TableCell align="right">
                          {MoneyFormatv3(editedItems?.paymentAmount)}
                        </TableCell>
                        <TableCell align="right">
                          <TextField
                            disabled={
                              editedItems.invoiceNumber.label !== "" &&
                              editedItems.paymentNumber.label !== ""
                                ? false
                                : true
                            }
                            onClick={moveCursorToEnd}
                            size="small"
                            fullWidth
                            name="linkedAmount"
                            id="linkedAmount"
                            type="text"
                            value={MoneyFormatv2(editedItems?.linkedAmount)}
                            sx={{
                              "& fieldset": { border: "none" },
                            }}
                            onChange={(e) => {
                              let value = e.target.value;
                              setRowIndex(index);
                              value = value.replace(/,/g, "");
                              if (!/^\d*(?:\.\d*)?$/.test(value)) {
                                return;
                              }
                              if (
                                value > 0 &&
                                value <= Number(editedItems.paymentAmount)
                              ) {
                                handleLinkedAmount(value);
                                setEditedItems((prev) => ({
                                  ...prev,
                                  linkedAmount: value,
                                }));
                              } else {
                                setEditedItems((prev) => ({
                                  ...prev,
                                  linkedAmount: 0,
                                }));
                                handleLinkedAmount(value);
                              }
                            }}
                            InputProps={{
                              inputProps: {
                                style: {
                                  textAlign: "right",
                                  paddingRight: "0px",
                                },
                                min: 0,
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell align="right">
                          {MoneyFormatv3(editedItems?.unlinkedPaymentAmount)}
                        </TableCell>
                        <TableCell align="right">
                          {MoneyFormatv3(editedItems?.invoiceBalanceAmount)}
                        </TableCell>

                        <TableCell align="center">
                          <>
                            <IconButton
                              disableRipple
                              aria-label="delete"
                              sx={{
                                margin: "0px 2px",
                                padding: "5px",
                                backgroundColor:
                                  col.new === true ? "#fbc7c78c" : "#83ff7b7a",
                              }}
                              onClick={() => {
                                closeChangesInRows(index);
                                setCloseEvent(true);
                                setRowIndex("");
                              }}
                            >
                              {col.new === true ? (
                                <CloseIcon
                                  sx={{
                                    fontSize: "18px",
                                    color: "#eb6a6a",
                                  }}
                                />
                              ) : (
                                <DoneIcon
                                  sx={{
                                    fontSize: "18px",
                                    color: "#34994f",
                                  }}
                                />
                              )}
                            </IconButton>
                          </>
                        </TableCell>
                      </TableRow>
                    </>
                  );
                } else {
                  return (
                    <TableRow key={index} height="40px">
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{col.date}</TableCell>
                      <TableCell sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                          style={{ marginRight: "8px", fontSize: "1rem" }}
                        >
                          {col?.invoiceNumber?.label}
                        </Typography>
                        <Chip
                          color="success"
                          icon={
                            <CurrencyRupeeIcon style={{ fontSize: "1rem" }} />
                          }
                          label={MoneyFormatv3(col?.invoiceBalanceAmount)}
                          size="small"
                          sx={{
                            m: 1,
                          }}
                        />
                      </TableCell>

                      <TableCell align="right">
                        {MoneyFormatv3(col?.invoiceAmount)}
                      </TableCell>
                      <TableCell sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                          style={{ marginRight: "8px", fontSize: "1rem" }}
                        >
                          {col?.paymentNumber.label}
                        </Typography>
                        <Chip
                          color="success"
                          icon={
                            <CurrencyRupeeIcon style={{ fontSize: "1rem" }} />
                          }
                          label={MoneyFormatv3(col?.unlinkedPaymentAmount)}
                          size="small"
                          sx={{
                            m: 1,
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        {MoneyFormatv3(col?.paymentAmount)}
                      </TableCell>
                      <TableCell align="right">
                        {MoneyFormatv3(col?.linkedAmount)}
                      </TableCell>
                      <TableCell align="right">
                        {MoneyFormatv3(col?.unlinkedPaymentAmount)}
                      </TableCell>
                      <TableCell align="right">
                        {MoneyFormatv3(col?.invoiceBalanceAmount)}
                      </TableCell>

                      <TableCell align="center">
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <IconButton
                            // disabled={
                            //   Object.keys(tempItems).length == 0 ? false : true
                            // }
                            disableRipple
                            aria-label="delete"
                            sx={{
                              margin: "0px 2px",
                              padding: "5px",
                              backgroundColor: "#b1d1f97d",
                            }}
                            onClick={() => {
                              // if (Object.keys(tempItems).length == 0) {
                              // settempItems(col);
                              // setEditedItems(col);
                              // let arr = [...items];
                              // arr[index].editable = true;
                              // arr[index].new = false;
                              // setItems(arr);
                              // setRowIndex(index);
                              // }
                              settempItems(col);
                              setEditedItems(col);
                              let arr = [...items];
                              let tempArr = arr.filter((ele, ind) => {
                                if (ele.new !== true) {
                                  if (ind == index) {
                                    ele.editable = true;
                                    ele.new = false;
                                  } else {
                                    ele.editable = false;
                                    ele.new = false;
                                  }
                                  return ele;
                                }
                              });
                              setItems(tempArr);

                              setRowIndex(index);
                            }}
                          >
                            <EditIcon
                              sx={{
                                fontSize: "15px",
                                color: "#6096d9",
                              }}
                            />
                          </IconButton>
                          <IconButton
                            // disabled={
                            //   Object.keys(tempItems).length == 0 ? false : true
                            // }
                            disableRipple
                            aria-label="delete"
                            sx={{
                              margin: "0px 2px",
                              padding: "5px",
                              backgroundColor: "#fbc7c78c",
                            }}
                            onClick={() => {
                              // if (Object.keys(tempItems).length == 0) {
                              setEntryIndex(index);
                              setDeleteEntriesModal(true);
                              // }
                            }}
                          >
                            <DeleteIcon
                              sx={{
                                fontSize: "15px",
                                color: "#eb6a6a",
                              }}
                            />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                }
              })
            ) : (
              <TableRow>
                <TableCell align="center" colSpan={10}>
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>

          <TableRow>
            <TableCell colSpan={10}>
              <Button
                disableElevation
                disableRipple
                size="small"
                variant="text"
                startIcon={<AddBox />}
                sx={{
                  fontSize: "14px",
                }}
                disabled={newItemRowStatus === true ? true : false}
                onClick={() => {
                  setNewItemRowStatus(true);
                  if (rowIndex !== "") {
                  } else {
                    itemWiseNewRow();
                  }
                }}
              >
                Add More Receipt
              </Button>
            </TableCell>
          </TableRow>
        </Table>
      </TableContainer>
      <DeletePayments
        open={deleteEntriesModal}
        setEntryRows={setItems}
        setOpen={setDeleteEntriesModal}
        setsuccessSnakbar={setsuccessSnakbar}
        setSnakbarTex={showSuccessSnackbar}
        entryRows={items}
        entryInd={entryIndex}
        DisplayLinkToInvoiceTable={(arr) => DisplayLinkToInvoiceTable(arr)}
      />
    </Paper>
  );
}

export default EntryTable;
